<!-- nav設定ボタン -->
<template>
  <div
    class="crly-a-contents-setting-btn crly-icon"
    @click="clickNavSettingBtn"
  ></div>
</template>

<script>
export default {
  name: "CrlyAtomsContentsSettingBtn",
  methods: {
    /**
     * 設定ボタンクリックイベント
     */
    clickNavSettingBtn() {
      this.$store.commit("menuStatus/setCategoryMenu", true);
      this.$emit("clickNavSettingBtn");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/contents/settingBtn.scss";
</style>
